import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = ["stroke"];
var _hoisted_3 = ["stroke"];
var _hoisted_4 = ["fill", "stroke"];
var _hoisted_5 = ["fill", "stroke"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartIcon',
    props: {
        color: {
            type: String,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M2.3989 3.25708L4.13223 3.55708L4.93473 13.1179C4.9989 13.8987 5.6514 14.4979 6.43473 14.4954H15.5256C16.2731 14.4971 16.9072 13.9471 17.0131 13.2071L17.8039 7.74208C17.8922 7.13125 17.4681 6.56458 16.8581 6.47625C16.8047 6.46875 4.41056 6.46458 4.41056 6.46458",
                    stroke: __props.color,
                    "stroke-width": "1.25",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_2),
                _createElementVNode("path", {
                    d: "M11.8781 9.5446H14.1889",
                    stroke: __props.color,
                    "stroke-width": "1.25",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_3),
                _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M6.06915 17.3843C6.31998 17.3843 6.52248 17.5876 6.52248 17.8376C6.52248 18.0884 6.31998 18.2918 6.06915 18.2918C5.81831 18.2918 5.61581 18.0884 5.61581 17.8376C5.61581 17.5876 5.81831 17.3843 6.06915 17.3843Z",
                    fill: __props.color,
                    stroke: __props.color,
                    "stroke-width": "1.25",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_4),
                _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M15.4694 17.3843C15.7202 17.3843 15.9236 17.5876 15.9236 17.8376C15.9236 18.0884 15.7202 18.2918 15.4694 18.2918C15.2186 18.2918 15.0161 18.0884 15.0161 17.8376C15.0161 17.5876 15.2186 17.3843 15.4694 17.3843Z",
                    fill: __props.color,
                    stroke: __props.color,
                    "stroke-width": "1.25",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_5)
            ]));
        };
    }
});
